import CBUtils from '@cb/apricot/CBUtils';
function CardTitle(_ref) {
  var title = _ref.title,
    id = _ref.id,
    whiteColor = _ref.whiteColor,
    cta = _ref.cta,
    children = _ref.children;
  var titleContent = title !== null && title !== void 0 ? title : children;
  if (titleContent) {
    return /*#__PURE__*/React.createElement("h3", {
      className: "cb-card-title".concat(whiteColor ? ' cb-white-color' : '').concat(cta ? ' cb-align-center cb-font-weight-light cb-margin-bottom-24' : ''),
      id: "".concat(id, "Title")
    }, titleContent);
  }
  return null;
}
function CardTitleLink(_ref2) {
  var title = _ref2.title,
    titleLink = _ref2.titleLink,
    id = _ref2.id,
    whiteColor = _ref2.whiteColor,
    cta = _ref2.cta,
    children = _ref2.children;
  var titleContent = title !== null && title !== void 0 ? title : children;
  if (titleLink) {
    return /*#__PURE__*/React.createElement("a", {
      href: titleLink,
      "aria-describedby": "".concat(id, "Header ").concat(id, "Content")
    }, /*#__PURE__*/React.createElement(CardTitle, {
      id: id,
      whiteColor: whiteColor,
      cta: cta
    }, titleContent));
  }
  return /*#__PURE__*/React.createElement(CardTitle, {
    id: id,
    whiteColor: whiteColor,
    cta: cta
  }, titleContent);
}
function Card(_ref3) {
  var id = _ref3.id,
    header = _ref3.header,
    title = _ref3.title,
    titleLink = _ref3.titleLink,
    content = _ref3.content,
    action = _ref3.action,
    className = _ref3.className,
    _ref3$cta = _ref3.cta,
    cta = _ref3$cta === void 0 ? false : _ref3$cta,
    _ref3$style = _ref3.style,
    style = _ref3$style === void 0 ? {} : _ref3$style,
    children = _ref3.children;
  // Generate an ID if not provided
  var derivedId = id || CBUtils.uniqueID(5);
  var whiteColor = className && className.includes('cb-white-color');
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-card".concat(cta ? ' cb-card-cta' : '').concat(className ? " ".concat(className) : ''),
    style: style
  }, header ? /*#__PURE__*/React.createElement("div", {
    className: "cb-card-header"
  }, /*#__PURE__*/React.createElement("p", {
    className: "cb-text-overline-small",
    id: "".concat(derivedId, "Header")
  }, header)) : null, /*#__PURE__*/React.createElement("div", {
    className: "cb-card-content",
    style: cta ? {
      justifyContent: 'center'
    } : {}
  }, /*#__PURE__*/React.createElement(CardTitleLink, {
    id: derivedId,
    titleLink: titleLink,
    whiteColor: whiteColor,
    cta: cta
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "cb-card-desc".concat(cta ? ' cb-align-center' : '').concat(whiteColor ? ' cb-white-color' : ''),
    style: cta ? {
      justifyContent: 'center'
    } : {},
    id: "".concat(derivedId, "Description")
  }, content !== null && content !== void 0 ? content : children), action ? /*#__PURE__*/React.createElement("div", {
    className: "cb-card-action",
    style: cta ? {
      justifyContent: 'center'
    } : {}
  }, action) : null));
}
export default Card;